<template>
  <BreadCrumb PageTitle="Documentation API – Changement de statut" />
  <DriverStatusApiDocs send-base-url />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DriverStatusApiDocs from "../../components/Users/DriverStatusApi/DriverStatusApiDocs.vue";

export default defineComponent({
  name: "DriverStatusApiDocsPage",
  components: {
    BreadCrumb,
    DriverStatusApiDocs,
  },
});
</script>
